module.exports = __webpack_public_path__ + "fonts/subset-Averta-Bold.cd061e0.woff2";